import Flex from 'components/reusable/flex'
import SvgFbSolidV2 from 'components/reusable/svg/share_buttons/svg_fb_solid_v2'
import SvgLinkedinSolidV2 from 'components/reusable/svg/share_buttons/svg_linkedin_solid_v2'
import SvgMailtoSolidV2 from 'components/reusable/svg/share_buttons/svg_mailto_solid_v2'
import SvgTgColoredSolid from 'components/reusable/svg/share_buttons/svg_tg_colored_solid'
import SvgWhatsAppOutline from 'components/reusable/svg/share_buttons/svg_whats_app_outline'
import { colors } from 'helpers/colors'
import React from 'react'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappShareButton
} from 'react-share'
import styled from 'styled-components'

const CircledWrapper = styled(Flex)`
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  border: 1px solid ${colors.gray[100]};
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background-color: ${colors.gray[50]};
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  }
`

const ScrollContainer = styled(Flex)`
  @media (max-width: 768px) {
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

const SHARE_MESSAGE = 'Hey, check out this cool app for booking models!'

const InviteViaSocials = ({ url }) => {
  return (
    <ScrollContainer jc="flex-start" ai="center" gap={8}>
      <CircledWrapper>
        <WhatsappShareButton url={url} title={SHARE_MESSAGE}>
          <SvgWhatsAppOutline size={25} />
        </WhatsappShareButton>
      </CircledWrapper>

      <CircledWrapper>
        <TelegramShareButton url={url} title={SHARE_MESSAGE}>
          <SvgTgColoredSolid size={25} />
        </TelegramShareButton>
      </CircledWrapper>

      <CircledWrapper>
        <FacebookShareButton url={url}>
          <SvgFbSolidV2 size={23} />
        </FacebookShareButton>
      </CircledWrapper>

      <CircledWrapper>
        <LinkedinShareButton url={url} title={SHARE_MESSAGE}>
          <SvgLinkedinSolidV2 size={23} />
        </LinkedinShareButton>
      </CircledWrapper>

      <CircledWrapper>
        <EmailShareButton url={url} subject={SHARE_MESSAGE}>
          <SvgMailtoSolidV2 size={25} />
        </EmailShareButton>
      </CircledWrapper>
    </ScrollContainer>
  )
}

export default InviteViaSocials
